<template>
  <div class="news-list-container">
    <div class="news-list__main-body">
      <div class="news-page-title">news</div>
      <div class="body__recommend-container">
        <div class="recommend__column" v-for="(column, index) in formatRecommend" :key="index">
          <div
            class="recommend__item"
            :class="{
              hoverShow: !$bowser.mobile
            }"
            v-for="(item, i) in column"
            :key="i"
          >
            <template v-if="item">
              <router-link
                :to="{
                  path: `/news/${encodeURIComponent(item.title)}/${item.id}`
                }"
              >
                <div class="item__cover scrollObj">
                  <img :src="item.cover" alt="" />
                </div>
                <div class="item__content scrollObj">
                  <div class="item__title">{{ item.title }}</div>
                  <div class="item__summary">{{ item.summary }}</div>
                  <div class="item__publish">{{ item.publish }}</div>
                </div>
              </router-link>
            </template>
          </div>
        </div>
      </div>
      <div class="body__news-lists-container">
        <div class="news-lists__inner">
          <div class="lists__title">
            <p>Latest news</p>
          </div>
          <div class="lists__container">
            <div class="lists__wrapper">
              <div
                class="lists__item"
                v-for="(item, index) in lists"
                :key="index"
                :class="{
                  hoverShow: !$bowser.mobile
                }"
              >
                <router-link
                  :to="{
                    path: `/news/${encodeURIComponent(item.title)}/${item.id}`
                  }"
                >
                  <div class="item__inner">
                    <div class="item__cover scrollObj">
                      <img :src="item.inner_big_img" alt="" />
                    </div>
                    <div class="item__content scrollObj">
                      <p class="item__publish">{{ item.publish }}</p>
                      <p class="item__title">{{ item.title }}</p>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <page-footer class="common-footer news-list"></page-footer>
  </div>
</template>

<script>
import { initNews } from '@/utils/data';
import pageFooter from '../common/footer.vue';

export default {
  name: 'page-news-list',
  components: {
    pageFooter,
  },
  data() {
    return {
      recommends: [],
      lists: [],
      page: 1,
      totalPage: 1,
    };
  },
  computed: {
    formatRecommend() {
      const that = this;
      const data = [];
      if (that.$bowser.mobile) {
        data[0] = [that.recommends['0'], that.recommends['1']];
        data[1] = [that.recommends['2'], that.recommends['3']];
      } else {
        that.recommends.forEach((item, index) => {
          const queue = index % 2;
          if (data[queue] === undefined) {
            data[queue] = [item];
          } else {
            data[queue].push(item);
          }
        });
      }

      return data;
    },
  },
  beforeRouteEnter(to, from, next) {
    initNews().then((res) => {
      next((vm) => {
        vm.setData(res);
      });
    });
  },
  beforeRouteUpdate() {},
  methods: {
    setData(data) {
      const recommend = data[0];
      const common = data[1];
      this.recommends = recommend;
      this.lists = common.list;
    },
  },
};
</script>

<style></style>
